//
import { useQuery } from '@tanstack/react-query';

import { useMySubscriptions } from '../subscriptions';

import { useLiveRecordFilterStore } from './useLiveRecordFilterStore';

import { sdk } from '@/services';
import { useProfile } from '@/store/profile';

const EventService = sdk.getService('EventService');

export const useStudentLiveRecordsByCourse = (courseIdOverride?: string) => {
  const { selectedSubscription } = useMySubscriptions();
  const {
    roleCheck: { isStudent }
  } = useProfile();
  const { filter } = useLiveRecordFilterStore();
  const computedCourseId = courseIdOverride || selectedSubscription?.course._id;

  const studentQuery = useQuery({
    queryKey: ['events', 'live-records', computedCourseId, filter, true],
    queryFn: () => EventService.findAllStudentLiveRecordsByCourse(computedCourseId!, filter),
    enabled: !!computedCourseId && isStudent
  });

  const nonStudentQuery = useQuery({
    queryKey: ['events', 'live-records', computedCourseId, false],
    queryFn: () => EventService.findCourseLiveRecords(computedCourseId!),
    enabled: !!computedCourseId && !isStudent
  });

  return {
    liveRecords: studentQuery.data ?? nonStudentQuery.data,
    isLoading: studentQuery.isLoading || nonStudentQuery.isLoading,
    error: studentQuery.error ?? nonStudentQuery.error
  };
};
